

// import React, { useState, useEffect } from "react";
// import ReactApexChart from "react-apexcharts";
// import { max } from "lodash";

// const getUniqueSeasons = (data) => {
//   const seasons = data.map((item) => item.season);
//   return [...new Set(seasons)];
// };

// const BankerRainfallIndices = ({ indices }) => {
//   const seasons = getUniqueSeasons(indices);
//   const [selectedSeason, setSelectedSeason] = useState(seasons[0]);
//   const [seriesData, setSeriesData] = useState([]);
//   const [monthsList, setMonthsList] = useState([]);
//   const [chartOptions, setChartOptions] = useState({});

//   const filterDataBySeason = (data, season) => {
//     return data.filter((item) => item.season === season);
//   };

//   const updateMonthsList = (season) => {
//     if (season === "Rabi") {
//       setMonthsList(["Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun"]);
//     } else if (season === "Kharif") {
//       setMonthsList(["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"]);
//     }
//   };

//   const prepareChartData = () => {
//     const seasonData = filterDataBySeason(indices, selectedSeason);
//     const monthlyData = {};

//     seasonData.forEach((item) => {
//       item?.indices.forEach((element) => {
//         const date = new Date(element.date);
//         const year = date.getFullYear();
//         const monthName = date.toLocaleString("default", { month: "short" });

//         if (!monthlyData[year]) {
//           monthlyData[year] = {};
//         }

//         if (!monthlyData[year][monthName]) {
//           monthlyData[year][monthName] = 0;
//         }

//         if ((monthlyData[year][monthName] || 0) < element.PRECIPITATION) {
//           monthlyData[year][monthName] = element.PRECIPITATION;
//         }
//       });
//     });

//     const series = Object.keys(monthlyData).map((year) => {
//       const dataForMonths = monthsList.map((month) => {
//         return monthlyData[year][month] || 0;
//       });
//       return {
//         name: `${selectedSeason} ${year}`,
//         data: dataForMonths,
//       };
//     });

//     setSeriesData(series);
//   };

//   useEffect(() => {
//     updateMonthsList(selectedSeason);
//   }, [selectedSeason]);

//   useEffect(() => {
//     prepareChartData();
//   }, [monthsList, selectedSeason]);

//   useEffect(() => {
//     const updatedOptions = {
//       grid: {
//         show: true,
//         borderColor: "#cadbdb",
//       },
//       chart: {
//         height: 500,
//         type: "area",
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       stroke: {
//         curve: "smooth",
//         width: 1,
//       },
//       colors: ["#2E93fA", "#66DA26", "#FF4560", "#775DD0"],
//       xaxis: {
//         categories: monthsList,
//         labels: {
//           formatter: function(value) {
//             return value;
//           },
//         },
//       },
//       yaxis: {
//         min: -0.1,
//         max: max(seriesData.map((s) => max(s.data))),
//         tickAmount: 5,
//         labels: {
//           formatter: function(value) {
//             return value.toFixed(2);
//           },
//         },
//       },
//       tooltip: {
//         enabled: true,
//         shared: true,
//         intersect: false,
//         x: {
//           format: "MMM",
//         },
//         y: {
//           formatter: function(value) {
//             return value.toFixed(2);
//           },
//         },
//       },
//     };
//     setChartOptions(updatedOptions);
//   }, [monthsList, selectedSeason]);

//   return (
//     <React.Fragment>
//       <div className="season-selector">
//         <label className="season-label">Select Season: </label>
//         <select
//           id="seasonSelect"
//           className="season-dropdown"
//           value={selectedSeason}
//           onChange={(e) => setSelectedSeason(e.target.value)}
//         >
//           {seasons.map((season) => (
//             <option key={season} value={season}>
//               {season}
//             </option>
//           ))}
//         </select>
//       </div>

//       <ReactApexChart
//         options={chartOptions}
//         series={seriesData}
//         type="area"
//         height="500"
//       />
//     </React.Fragment>
//   );
// };

// export default BankerRainfallIndices;



import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { max } from "lodash";

const getUniqueSeasons = (data) => {
  return [...new Set(data.map((item) => item.season))];
};

const filterDataBySeason = (data, season) => {
  return data.filter((item) => item.season === season);
};

const getMonthsList = (season) => {
  return season === "Rabi"
    ? [ "Dec", "Jan", "Feb", "Mar", "Apr", "May", ]
    : [ "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"];
};

const prepareChartData = (indices, season) => {
  const seasonData = filterDataBySeason(indices, season);
  const monthsList = getMonthsList(season);
  const monthlyData = {};

  seasonData.forEach((item) => {
    item?.indices.forEach((element) => {
      const date = new Date(element.date);
      const year = date.getFullYear();
      const monthName = date.toLocaleString("default", { month: "short" });

      if (!monthlyData[year]) {
        monthlyData[year] = {};
      }

      if (!monthlyData[year][monthName]) {
        monthlyData[year][monthName] = 0;
      }

      if ((monthlyData[year][monthName] || 0) < element.PRECIPITATION) {
        monthlyData[year][monthName] = element.PRECIPITATION;
      }
    });
  });

  const series = Object.keys(monthlyData).map((year) => ({
    name: `${season} ${year}`,
    data: monthsList.map((month) => monthlyData[year][month] || 0),
  }));

  return { series, monthsList };
};

const getChartOptions = (monthsList, seriesData) => ({
  grid: {
    show: true,
    borderColor: "#cadbdb",
  },
  chart: {
    height: 500,
    type: "area",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 1,
  },
  colors: ["#2E93fA", "#66DA26", "#FF4560", "#775DD0"],
  xaxis: {
    categories: monthsList,
    labels: {
      formatter: (value) => value,
    },
  },
  yaxis: {
    min: 0,
    max: max(seriesData.map((s) => max(s.data))),
    tickAmount: 5,
    labels: {
      formatter: (value) => value.toFixed(2),
    },
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    x: { format: "MMM" },
    y: { formatter: (value) => value.toFixed(2) },
  },
});

const BankerRainfallIndices = ({ indices }) => {
  const [kharifData, setKharifData] = useState({ series: [], monthsList: [] });
  const [rabiData, setRabiData] = useState({ series: [], monthsList: [] });

  useEffect(() => {
    setKharifData(prepareChartData(indices, "Kharif"));
    setRabiData(prepareChartData(indices, "Rabi"));
  }, [indices]);

  return (
    // <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          <div style={{ display: "grid", gap: "20px" }} className="responsive-grid">

      <div style={{ flex: "1 1 45%" }}>
        <h3 style={{ textAlign: "center" }}>Kharif</h3>
        <ReactApexChart
          options={getChartOptions(kharifData.monthsList, kharifData.series)}
          series={kharifData.series}
          type="area"
          height="400"
        />
      </div>

      <div style={{ flex: "1 1 45%" }}>
        <h3 style={{ textAlign: "center" }}>Rabi</h3>
        <ReactApexChart
          options={getChartOptions(rabiData.monthsList, rabiData.series)}
          series={rabiData.series}
          type="area"
          height="400"
        />
      </div>
    </div>
  );
};

export default BankerRainfallIndices;
